const setupFixedNav = (el) => {
  let lastKnownScrollPos = window.scrollY
  let ticking = false

  function updateScrollState() {
    if (lastKnownScrollPos > 100) {
      el.classList.add('is-visible')
    } else {
      el.classList.remove('is-visible')
    }

    ticking = false
  }

  function requestTick() {
    if (!ticking) {
      window.requestAnimationFrame(updateScrollState)
      ticking = true
    }
  }

  function onScroll() {
    lastKnownScrollPos = window.scrollY
    requestTick()
  }

  el.addEventListener('click', () => {
    window.dispatchEvent(new Event('navigation:show'))
  })

  window.addEventListener('scroll', onScroll, {
    passive: true,
  })

  window.addEventListener('navigation:out', () => {
    el.classList.remove('is-visible')
  })
}

export default setupFixedNav
